module.exports = __webpack_public_path__ + "fonts/antonio-regular-unhinted-webfont.4a1af3af.woff";